<template>
	<div class="contentPage">
		<div class="statistics">
			<div class="headWrap">
				<div class="statistics_title">Safety RFM statistics</div>
				<button class="mainBtn mainBtn-text iconHoverRotate" @click="onRefresh()">
          <span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
					<span class="btnText">Refresh date</span>
				</button>
			</div>
			<div class="statistics_graph">
				<div class="statistics_graph-wrap">
					<div class="statistics_graph-top">
						<field
								margin="0"
								label="Years"
								placeholder="Select years"
								@updateAutocomplete="onAutocomplete($event, 'selectedYear')"
								:autocompleteValue="selectedYear"
								:items="years"
								:isClearable="false"
								is-autocomplete
								is-required
						></field>
						<div class="right">

							<field
									width="130px"
									margin="0 0 0 10px"
									label-switch="Customers"
									:switch-value="isStackedB"
									@updateSwitch="onSwitch($event, 'isStackedB')"
									is-switch
									is-off-style
									is-dense
							></field>

							<field
									width="130px"
									margin="0 0 0 10px"
									label-switch="Drivers"
									:switch-value="isStackedA"
									@updateSwitch="onSwitch($event, 'isStackedA')"
									is-switch
									is-off-style
									is-dense
							></field>
						</div>
					</div>

					<reactive-bar-chart
							v-if="safetyStatisticGraphData && safetyStatisticGraphOptions"
							class="trailers-chart"
							:chart-data="safetyStatisticGraphData"
							:graph-a="isStackedA"
							:graph-b="isStackedB"
							:options="safetyStatisticGraphOptions"
							@updatePoint="onPoint"
					></reactive-bar-chart>

				</div>
			</div>

		</div>

		<dialog-table
				v-if="isDialogTable"
				:list="safetyStatisticRow"
				title="Customers list"
				:headers="safetyStatisticHeaders"
				flag="CustomersListHeaders"
				@updateClose="onCloseDialogTable"
				@updateModEvent="onModEvent"
		/>

		<dialog-info
				v-if="isDialogInfo"
				:title="titleDialogInfo"
				:text="textDialogInfo"
				@updateApply="onDialogInfoApply"
				@updateClose="onDialogInfoApply"
		/>
		<customer-form
				v-if="isCustomerForm"
				:id="idCustomer"
				@updateClose="onCloseCustomerForm"
				@updateSave="onSaveCustomerForm"
		></customer-form>

		<preload v-if="isPreloader"></preload>

	</div>
</template>

<script>

import { safetyStatisticHeaders } from "@/constants/defaultHeader";
import { mapActions, mapGetters } from "vuex";
// components

// shared
import ReactiveBarChart from "@/shared/chart2/chart2";
import Preload from "@/shared/Preload/Preload.vue";

// constants

// mixins
import settingsMixins from "@/mixins/settingsMixins";
import previewMixins from "@/mixins/previewMixins";
import DialogTable from "@/shared/DialogTable/DialogTable.vue";
import CustomerForm from "@/components/Maintenance/Customer/CustomerForm/CustomerForm.vue";
import DialogInfo from "@/shared/DialogInfo/DialogInfo.vue";

export default {
	name: "SafetyStatistic",
	mixins: [ settingsMixins, previewMixins ],
	components: {
		DialogInfo,
		CustomerForm,
		DialogTable,
		ReactiveBarChart,
		Preload,
	},
	computed: {
		...mapGetters([
			"safetyStatisticGraphData",
			"safetyStatisticGraphOptions",
			"safetyStatisticDate",
			"safetyStatisticRow",
		]),
	},

	created() {
		this.years = this.getYearsList(2000, new Date().getFullYear());
	},
	data: () => ({
		safetyStatisticHeaders: safetyStatisticHeaders,
		isDispatchReports: null,
		isStackedA: true,
		isStackedB: true,
		isPreloader: false,
		isDialogTable: false,

		selectedYear: new Date().getFullYear(),
		years: [],

		isDialogInfo: false,
		titleDialogInfo: null,
		textDialogInfo: null,

		isCustomerForm: false,
		idCustomer: null,
	}),
	methods: {
		...mapActions([
			"getSafetyStatistic",
			"getSafetyStatisticDate",
			"getSafetyStatisticYear",
			"updateSafetyStatistic",
		]),

		onModEvent(args) {
			const { line, flag } = args;

			if (flag === 'link') {
				this.isCustomerForm = true;
				this.idCustomer = line.customer_id;
			}
			if (flag === 'info') {
				const title = `Safety Service Info — <b>${ line.customer_name }</b>`;
				const text = line.information;
				this.initDialogInfo({ title, text });
			}
		},
		initDialogInfo(args) {
			const { title, text } = args;
			this.titleDialogInfo = title;
			this.textDialogInfo = text;
			this.isDialogInfo = true;
		},
		onDialogInfoApply() {
			this.isDialogInfo = false;
		},

		onSaveCustomerForm() {
			this.onCloseCustomerForm();
			// this.externalRefresh();
		},
		onCloseCustomerForm() {
			this.isCustomerForm = false;
			this.idCustomer = null;
		},

		async onRefresh() {
			this.isPreloader = true;
			await this.updateSafetyStatistic();
			await this.getSafetyStatistic();
			this.isPreloader = false;
		},

		onSwitch({ value }, key) {
			this[key] = value;
		},
		async onPoint(args) {
			this.isPreloader = true;
			const { index } = args;
			const date = this.safetyStatisticDate[index];
			await this.getSafetyStatisticDate(date);
			this.isDialogTable = true;
			this.isPreloader = false;
		},
		onCloseDialogTable() {
			this.isDialogTable = false;
		},
		getYearsList(start, end) {
			const list = [];
			for (let i = end; i >= start; i--) {
				list.push(i);
			}
			return list;
		},
		async onAutocomplete({ value }, key) {
			this.isPreloader = true;
			this[key] = value;
			if (key === "selectedYear") {
				await this.getSafetyStatisticYear({ year: this.selectedYear } );
			}
			this.isPreloader = false;
		},
	},
	async mounted() {
		this.isPreloader = true;
		// await this.updateSafetyStatistic();
		await this.getSafetyStatistic();
		// await this.getSafetyStatisticDate(this.date);
		// await this.getSafetyStatisticYear({ year: this.year } );
		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">

.statistics {
	margin: 0 45px;

	.headWrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.filterItem {
		display: flex;
		align-items: center;

		&_text {
			color: var(--card-color);
			text-align: right;
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
		}
	}

	&_top {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	&_title {
		font-size: 30px;
		font-weight: 500;
		line-height: 40px;
		letter-spacing: 0.25px;
		text-align: left;
		color: var(--card-color);
	}

	&_graph {
		display: grid;
		grid-gap: 30px;
		grid-template-columns: 1fr;
		align-items: start;

		&-top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			.right {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				flex-grow: 1;
			}
		}

		&-wrap {
			background: var(--card-bg);
			width: 100%;
			padding: 30px 40px;
			height: 595px;
			border-radius: 5px;
			margin-bottom: 40px;
		}
	}
}
</style>
